import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface Props {
  title: string;
  description: string;
  items?: string[];
  bgColor: string;
}

const BitaCoreIndexCard: React.FC<Props> = ({
  title,
  description,
  items,
  bgColor,
}) => {
  return (
    <Box
      sx={{
        height: { xs: "auto", md: "100%" },
        padding: "1.5rem",
        margin: { xs: "0.75rem 0", md: 0 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        color: "#1B1B1B",
        borderRadius: "2px",
        backgroundColor: bgColor,
      }}
    >
      <Box>
        <Box
          sx={{
            fontSize: 30,
            lineHeight: 1.2,
            fontWeight: 600,
          }}
        >
          {title}
        </Box>
        <Box
          sx={{
            fontSize: 16,
            lineHeight: 1.2,
            paddingTop: "0.5rem",
          }}
        >
          {description}
        </Box>
        {items && (
          <Box sx={{ paddingTop: "2rem", fontWeight: 600 }}>
            <ul style={{ listStyle: "disc", paddingLeft: "1.5rem" }}>
              {items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          paddingTop: "1.5rem",
          display: "flex",
          alignItems: "center",
          fontWeight: 600,
        }}
      >
        <ChevronRightIcon fontSize="small" />
        <Link to="/contact-us" target="_blank">
          Learn More
        </Link>
      </Box>
    </Box>
  );
};

export default BitaCoreIndexCard;
